jQuery(window).on('resize',function() {
    (function($) {
        if ($("input").is(":focus")) {
            // input is in focus, don't do nothing or input loses focus and keyboard dissapears
        } else {
            if ($(window).width() <= 767) {
                moveSearchMobile();
            } else if ($(window).width() >= 768) {
                moveSearchDesktop();
            }
        }
    })(jQuery);
});

jQuery(document).ready(function($) {
    $(window).trigger('resize');
    let navButton = $('#mobile-menu-button');
    let nav = $('#genesis-nav-primary');

    if ($("input").is(":focus")) {
    } else {
        if ($(window).width() <= 767) {
            navButton.click(function() {
                $('body').toggleClass('nav-open');
                $('.hamburger').toggleClass('active');
                nav.toggleClass('fikso_shownav');
            });

            window.addEventListener('load', function() {
                fastClickNav = document.getElementsByClassName('menu-item-has-children');
                FastClick.attach(fastClickNav);
            }, false);
        }
    }
});

function moveSearchMobile(){
    jQuery("#woocommerce_product_search-4, #woocommerce_product_search-5").appendTo("header.site-header");
}

function moveSearchDesktop() {
    jQuery("#woocommerce_product_search-4, #woocommerce_product_search-5").appendTo("header.site-header > .wrap");
}